<template>
    <div class="tables">
        <p for="" style="font-size: 1.2rem;">Checkpoint: <span style="font-weight: bold;">{{ checkpoint && checkpoint.name ? checkpoint.name : '' }}</span></p>
        <div class="d-flex justify-content-between align-items-center" style="flex-wrap: wrap; gap:14px;">
            <router-link class="mr-3" :to="{ name: 'checkpoints-checkin', params:{ id: $route.params.checkpointId } }">
                <el-tooltip content="Scanner" placement="top">
                    <el-button title="More">
                        Back to checkin page
                    </el-button>
                </el-tooltip>
            </router-link>

            <div class="d-flex" style="gap: 14px; flex-wrap: wrap;">
                <el-button v-if="userHasPermissions(['downloadCheckpointReports'])" @click="downloadAsReport" :loading="loading" class="btn btn-primary m-0">
                    Download
                    <fa class="ml-2" icon="download"/>
                </el-button>
                <el-button
                    class="m-0"
                    title="Search Using QR"
                    @click="scannerDialogOpen = true"
                >
                    Search Using QR
                </el-button>
    
                <el-button @click="refresh" :loading="loading" class="btn btn-secondary m-0">
                    Refresh
                </el-button>
            </div>
            
        </div>
        <div class="d-flex justify-content-between align-items-center" style="flex-wrap: wrap;">
            <el-input
                v-model="filter.code"
                placeholder="Code"
                class="col-12 col-sm m-0 p-0 mr-3"
                style="min-width: 250px;"
            />
            <el-input
                v-model="filter.regNoOrId"
                placeholder="Registration"
                class="col-12 col-sm m-0 p-0 mr-3"
                style="min-width: 250px;"
            />
            <el-input
                v-model="filter.name"
                placeholder="Registrant Name (lastname, firstname)"
                class="col-12 col-sm m-0 p-0 mr-3"
                style="min-width: 250px;"
            />
            <CustomSelect 
                style="width: 250px;"
                class="mr-3"
                placeholder="Select filters"
                multiple
                v-model="filter.status"
                :options="[
                    { label: 'Printed', value: 'printed' },
                    { label: 'Checked In', value: 'checked-in' },
                    { label: 'Checked Out', value: 'checked-out' },
                    { label: 'Accepted', value: 'accepted' },
                    { label: 'Deleted', value: 'deleted' }]
                " 
            />
            <el-button @click="runFilter" class="btn">Search</el-button>
        </div>

        <div class="d-flex justify-content-end">
            <el-button
                v-if="filter.running"
                @click="resetFilter"
                style="background-color: #25a5f5 !important; color: #fff !important;"
                class="mt-1"
            >
                <fa icon="times" /> &nbsp;&nbsp; Remove Filter
            </el-button>
        </div>

        <div class="d-flex align-items-center" style="gap:10px; flex-wrap: wrap;">
            <p class="d-flex align-items-center" style="gap:7px;">
                <span style="">Checked-In: </span>
                <span style="font-weight: bold; font-size: 1.1rem;">{{ stats['checked-in'] }},</span>
            </p>
            <p class="d-flex align-items-center" style="gap:7px;">
                <span style="">Accepted: </span>
                <span style="font-weight: bold; font-size: 1.1rem;">{{ stats['accepted'] }},</span>
            </p>
            <p class="d-flex align-items-center" style="gap:7px;">
                <span style="">Checked-out: </span>
                <span style="font-weight: bold; font-size: 1.1rem;">{{ stats['checked-out'] }}</span>
            </p>
            <p class="d-flex align-items-center" style="gap:7px;">
                <span style="">Deleted: </span>
                <span style="font-weight: bold; font-size: 1.1rem;">{{ stats['deleted'] }}</span>
            </p>
        </div>

        
        <div v-if="initializing || loading" class="d-flex justify-content-center py-4">
            <Loading />
        </div>
        <div v-else-if="checkins.length > 0" style="position: relative; border: 1px solid rgb(160, 160, 160);" v-for="(checkin, idx) in checkins" :key="checkin._id">
            <div style="position: absolute; top: -9px; z-index:100; left: 50px; display: flex; gap:5px;">
                <el-tag class="border status-tag" 
                    :style="getColorForStatus(checkin.status)"
                >
                    {{ checkin.status }}
                </el-tag>
                
                <el-tag class="bg-secondary border">
                    {{ checkin.registrantIds.length }}
                </el-tag>
                <el-tag 
                    v-if="checkin.printed"
                    class="border status-tag" 
                    :style="getColorForStatus('printed')"
                >
                    printed
                </el-tag>
            </div>
            <div class="responsive-table">
                <table>
                    <thead>
                            <th>
                                <el-dropdown
                                    placement="top-start"
                                    trigger="click"
                                    @command="execCommand"
                                >
                                    <span class="el-dropdown-link">
                                        <!-- <el-tooltip content="More" placement="top-start"> -->
                                            <el-button size="mini" title="More">
                                                <fa :icon="['fas', 'ellipsis-v']" />
                                            </el-button>
                                        <!-- </el-tooltip> -->
                                    </span>
                                    <el-dropdown-menu slot="dropdown" >
                                        <el-dropdown-item v-if="!['deleted'].includes(checkin.status)" :command="{idx, data: checkin, action: 'printed'}" >Print</el-dropdown-item>
                                        <el-dropdown-item v-if="!['deleted'].includes(checkin.status)" :command="{idx, data: checkin, action: 'deleted'}" >Delete</el-dropdown-item>
                                        <el-dropdown-item v-if="!['accepted', 'deleted'].includes(checkin.status)" :command="{idx, data: checkin, action: 'accepted'}" >Accept</el-dropdown-item>
                                        <el-dropdown-item v-if="['accepted'].includes(checkin.status)" :command="{idx, data: checkin, action: 'removed-accepted'}" >Remove Accepted</el-dropdown-item>
                                        <el-dropdown-item v-if="!['deleted'].includes(checkin.status)" :command="{idx, data: checkin, action: 'checked-out'}" >Checkout</el-dropdown-item>
                                        <el-dropdown-item :command="{idx, data: checkin, action: 'edit'}" >Add / Update Note</el-dropdown-item>
                                        <el-dropdown-item :command="{idx, data: checkin, action: 'view-registration'}" >View Registration</el-dropdown-item>
                                        <el-dropdown-item :command="{idx, data: checkin, action: 'view-logs'}" >View Logs</el-dropdown-item>
                                        <el-dropdown-item v-if="(checkpoint && checkpoint.additionalSettings && checkpoint.additionalSettings.sendAutoConfirmationEmail) && userHasPermissions(['checkpointResendCheckinConfirmationEmail'])" :command="{idx, data: checkin, action: 'resend-confirmation-email'}" >Resend Confirmation Email</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </th>
                            <th style="min-width: 180px;">Name</th>
                            <th style="min-width: 150px;">Timestamp</th>
                            <th v-for="cf in fieldsToShow">
                                {{ cf.title }}
                            </th>
                    </thead>
        
                    <tbody>
                        <tr v-for="atId in checkin.registrantIds">

                            <template v-if="checkin.populatedAttendeeIds.includes(atId)">
                                <td>
                                    <el-tooltip content="Edit" placement="top">
                                        <el-button @click="editAttendee(checkin.attendees.find(el => el._id == atId), checkin)" size="mini" title="Edit">
                                            <fa :icon="['fas', 'pen']" />
                                        </el-button>
                                    </el-tooltip>
                                </td>
                                <td>{{ getNameForCheckin(atId, checkin) }}</td>
                                <td>{{ checkin.createdAt | formatTimestamp }}</td>
                                <td v-for="fd in fieldsToShow">
                                    <template v-if="fd.type == 'radio'">
                                        {{ fd.labels.split('\n')[fd.values.split('\n').indexOf(getValueForField(fd, checkin.attendees.find(el => el._id == atId), checkin))] }}
                                    </template>
                                    <template>
                                        {{ getValueForField(fd, checkin.attendees.find(el => el._id == atId), checkin) }}
                                    </template>
                                </td>
                            </template>

                            <template v-else>
                                <td>
                                    <el-button disabled size="mini" title="Edit">
                                        <fa :icon="['fas', 'pen']" />
                                    </el-button>
                                </td>
                                <td>{{ getNameForCheckin(atId, checkin) }}</td>
                                <td>{{ checkin.createdAt | formatTimestamp }}</td>
                                <td v-for="fd in fieldsToShow">
                                    <template v-if="fd.type == 'radio'">
                                        {{ getValueFromData(fd, atId) }}
                                    </template>
                                    <template>
                                        {{ getValueFromData(fd, atId) }}
                                    </template>
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
                <div class="p-3 d-flex align-items-center" style="font-size: 1rem; gap:20px;">
                    <div>
                        <span class="mr-2"> Code: </span>
                        <span style="font-weight: bold; font-size: 1.2rem;">{{ checkin.code }}</span>
                    </div>
                    <div>
                        <span class="mr-2">Registration: </span>
                        <span style="font-weight: bold; font-size: 1.2rem;">{{ checkin.confirmationNumber }}</span>
                    </div>
                </div>

                <p v-if="checkin.note" class="pl-3" style="font-size: 1rem; display: flex; gap:5px;">
                    <span class="mr-2">Note: </span>
                    <span class="quill-editor" v-html="checkin.note"></span>
                </p>
            </div>
        </div>
        <div v-else class="d-flex justify-content-center align-items-center py-4">
            <div class="d-flex justify-content-center align-items-center py-4" style="flex-direction: column; gap:10px" v-if="filter.regNoOrId">
                <div>No checkins yet</div>
                <div>
                    Try checking in
                    <router-link
                        :to="{ 
                            name: 'checkpoints-checkin', 
                            params: { type: 'checkpoint', id: $route.params.checkpointId },
                            query: { regNoOrId: filter.regNoOrId },
                        }"
                    >
                        Checkin
                    </router-link>
                </div>
            </div>
        </div>

        <div v-if="pagination.total && checkins.length > 0" class="row">
            <div class="col-12 d-flex justify-content-end">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    @size-change="handlePageChange"
                    @current-change="handlePageChange"
                    :current-page.sync="pagination.page"
                    :total="pagination.total"
                    :page-size.sync="pagination.perPage"
                    :page-sizes="[50, 100, 200, 400, 500, 1000]">
                </el-pagination>
            </div>
        </div>


        <el-dialog 
            :close-on-click-modal="false"
            :visible.sync="viewingPrimaryRegDialog">
            <label for="notes" style="font-size: 1rem;">Primary Registration</label>
            <pre v-html="primaryRegDetails" ></pre>
        </el-dialog>

        <el-dialog 
            :close-on-click-modal="false"
            :visible.sync="noteData.dialogOpen">
            <label for="notes" style="font-size: 1rem;">Notes</label>
            <Editor id="notes" v-model="noteData.checkin.note" />
            <el-button @click="updateCheckinNote" :loading="loading" style="width: 100%;" class="btn btn-primary mt-4">Save</el-button>
        </el-dialog>

        <el-dialog
            v-if="scannerDialogOpen"
            :close-on-click-modal="false"
            :visible.sync="scannerDialogOpen">
            <QrScanner @onDecode="searchUsingScanner" />
            <p class="d-flex justify-content-center mt-2" style="color: gray;">Switch camera here if needed</p>
        </el-dialog>

        <el-dialog
            v-if="editData.dialogOpen"
            :close-on-click-modal="false"
            :visible.sync="editData.dialogOpen">
            <div style="background: #fff;" class="p-2">
                <template v-if="editData.fields.length">
                    <CheckinDataForm
                        hideEditButton
                        noClickOutsideDetection
                        class="my-3"
                        :fields="editData.fields" 
                        :registration="editData.registration"
                        @change="handleCheckpointFieldDataChange"
                        mode="edit"
                    />
                    <el-button :loading="editData.loading" @click="updateFields" class="mt-2" style="width: 100%">Save</el-button>
                </template>
                <template v-else>
                    <p class="d-flex justify-content-center">No fields to edit</p>
                </template>
            </div>
        </el-dialog>

        <el-dialog
            v-if="logData.dialogOpen"
            :close-on-click-modal="false"
            :visible.sync="logData.dialogOpen">
            <div v-if="logData.loading" class="d-flex justify-content-center">
                <Loading />
            </div>
            <p v-else-if="logData.logs.length == 0" class="d-flex justify-content-center py-4">No logs to show</p>
            <div v-else>
                <el-table
                    :data="logData.logs">
                        <!-- <el-table-column label="Attendee">
                            <template slot-scope="props">
                                {{ props.row.RegistrantFirstName }} {{ props.row.RegistrantLastName }}
                            </template>
                        </el-table-column> -->
                        <el-table-column label="Change">
                            <template slot-scope="props">
                                {{ props.row.change ? props.row.change : props.row.data.status }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Timestamp">
                            <template slot-scope="props">
                                {{ props.row.createdAt | formatTimestamp }}
                            </template>
                        </el-table-column>
                        <el-table-column label="By">
                            <template slot-scope="props">
                                {{ getCreator(props.row.creator) }}
                            </template>
                        </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import http from '../../http'
import Editor from '../../components/Editor.vue'
import Loading from "../Loading.vue"
import CustomSelect from "../../components/CustomSelect.vue"
import QrScanner from '../../components/QrScanner.vue'
import CheckinDataForm from "../../components/CheckinDataForm.vue"
import { mapState } from 'vuex';
import download from 'downloadjs'
import swal from 'sweetalert2';

export default {
    components: {
        Editor,
        Loading,
        CustomSelect,
        QrScanner,
        CheckinDataForm
    },
    props:{
        checkpointId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            checkpoint: null,
            checkins:[],
            initializing: false,
            loading: false,
            viewingPrimaryRegDialog: false,
            primaryRegDetails: null,
            noteData:{
                dialogOpen: false,
                idx: null,
                checkin: {
                    note: ""
                },
            },
            filter:{
                status: [],
                name: null,
                regNoOrId: null,
                code: null,
                running: false
            },
            scannerDialogOpen: false,
            fieldDatas: [],
            checkpointFields: [],
            editData:{
                fields: [],
                registration: {},
                recordedCheckpointFieldData: [],
                dialogOpen: false,
                loading: false
            },
            fieldsToShow: [],
            logData:{
                logs: [],
                dialogOpen: false,
                loading: false
            },
            downloading: false,
            pagination:{
                total: 0,
                page: 1,
                perPage: 10
            },
            checkpointFieldInfo: {},
            stats: {
                'checked-in': 0,
                'checked-out': 0,
                'accepted': 0,
                'deleted': 0,
            }
        }
    },
    computed:{
        ...mapState(['fields', 'checkpoints', 'user', 'event']),
    },
    methods: {
        getNameForCheckin(atId, checkin){
            const found = checkin.names.find(el => el._id == atId)
            return found ? (found.firstName + ' ' + found.lastName) : ""
        },
        async handlePageChange(){
            this.checkins = []
            this.loading = true
            if(this.filter.running){
                return this.runFilter()
            }
            await this.fetchCheckins()
            this.loading = false
        },
        userHasPermissions(permissions) {
            if (this.user.admin) return true;
            const roles = this.event.adminRoles && this.user._id && this.event.adminRoles[this.user._id] ? this.event.adminRoles[this.user._id] : []
            let valid = true
            permissions.forEach(per => {
                if (!roles[per]) valid = false;
            })
            return valid;
        },
        async getLogs(checkinId){
            this.logData.dialogOpen = true;
            this.logData.loading = true
            try {
                const res = await http.get(`/api/checkpoint-log/checkin?checkinId=${checkinId}`);
                this.logData.logs = res.data.logs
            } catch (error) {
                this.$store.dispatch('handleErrors', error)
            }
            this.logData.loading = false
        },
        async print(checkin) {
            let checkpointName = this.checkpoint.name;
            let code = checkin.code;
            let confirmationNumber = checkin.attendees[0].confirmationNumber;
            let labels = []
            const res = await http.get(`/api/checkpointfields-data?eventId=${this.$route.params.eventId}&registration=${confirmationNumber}&isConfirmationNumber=true`);
            const checkpointFieldData = res.data.data;
            const printOnBadgeFields = this.checkpoint.fieldsForCheckinAndAttendeesPage.filter(f => f.printInfoOnBadge)

            checkin.attendees.forEach(at =>{
                let names = this.getNameFromRegistration(at).split(',')
                const regCheckpointFieldData = checkpointFieldData.find(cfd => cfd.registration == at._id)
                const regPrintOnBadgeValues = []
                printOnBadgeFields.forEach(f => {
                    let val = this.getFieldValueFromRegistration(f._id, regCheckpointFieldData)
                    if(val) regPrintOnBadgeValues.push(val)
                })
                // console.log(regPrintOnBadgeValues);
                labels.push(
                    `<?xml version="1.0" encoding="utf-8"?>
                        <DieCutLabel Version="8.0" Units="twips">
                            <PaperOrientation>Landscape</PaperOrientation>
                            <Id>ZipDisk</Id>
                            <IsOutlined>false</IsOutlined>
                            <PaperName>30370 Zip Disk</PaperName>
                            <DrawCommands>
                                <RoundRectangle X="0" Y="0" Width="2880" Height="3375" Rx="270" Ry="270" />
                            </DrawCommands>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${checkpointName}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="14" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="344" Y="1527" Width="1764" Height="311.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <BarcodeObject>
                                    <Name>BARCODE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <Text>${at._id}</Text>
                                    <Type>QRCode</Type>
                                    <Size>Large</Size>
                                    <TextPosition>None</TextPosition>
                                    <TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <TextEmbedding>None</TextEmbedding>
                                    <ECLevel>0</ECLevel>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
                                </BarcodeObject>
                                <Bounds X="2163" Y="1395" Width="1095" Height="1044" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <ShapeObject Stroke="SolidLine">
                                    <Name>SHAPE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <ShapeType>HorizontalLine</ShapeType>
                                    <LineWidth>15</LineWidth>
                                    <LineAlignment>Center</LineAlignment>
                                    <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
                                </ShapeObject>
                                <Bounds X="317" Y="1350" Width="2775" Height="15" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_1</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${names[1].toUpperCase()}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="24" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="195" Width="2851" Height="497.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_2</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${names[0].toUpperCase()}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="20" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="843.000000000001" Width="2805" Height="366" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_3</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${code}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="14" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="1983" Width="1798" Height="357" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_4</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${ confirmationNumber} | ${ checkin.attendees.length } ${ regPrintOnBadgeValues.length ? ' | ' + regPrintOnBadgeValues.join(' | ') : '' }</String>
                                            <Attributes>
                                                <Font Family="Century Gothic" Size="12" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="2494" Width="2835" Height="165" />
                            </ObjectInfo>
                        </DieCutLabel>
                `)
            });

            labels.push(
                `<?xml version="1.0" encoding="utf-8"?>
                        <DieCutLabel Version="8.0" Units="twips">
                            <PaperOrientation>Landscape</PaperOrientation>
                            <Id>ZipDisk</Id>
                            <IsOutlined>false</IsOutlined>
                            <PaperName>30370 Zip Disk</PaperName>
                            <DrawCommands>
                                <RoundRectangle X="0" Y="0" Width="2880" Height="3375" Rx="270" Ry="270" />
                            </DrawCommands>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>CenterBlock</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${checkpointName}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="353.000000000001" Y="1593" Width="2769" Height="371.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <ShapeObject Stroke="SolidLine">
                                    <Name>SHAPE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <ShapeType>HorizontalLine</ShapeType>
                                    <LineWidth>15</LineWidth>
                                    <LineAlignment>Center</LineAlignment>
                                    <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
                                </ShapeObject>
                                <Bounds X="317" Y="1470" Width="2880" Height="15" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_1</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${code}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="20" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="315" Width="1447" Height="467.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_2</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">Count: ${checkin.attendees.length}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="903.000000000001" Width="1398" Height="456" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_3</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">Registration: ${confirmationNumber}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="11" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="347.999999999999" Y="2025" Width="2772" Height="300" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_4</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>CenterBlock</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">Retain this label for Checkout</String>
                                            <Attributes>
                                                <Font Family="Arial" Size="10" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="2446" Width="2880" Height="270" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <BarcodeObject>
                                    <Name>BARCODE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <Text>${checkin.attendees[0]._id}</Text>
                                    <Type>QRCode</Type>
                                    <Size>Medium</Size>
                                    <TextPosition>None</TextPosition>
                                    <TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <TextEmbedding>None</TextEmbedding>
                                    <ECLevel>0</ECLevel>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
                                </BarcodeObject>
                                <Bounds X="1818" Y="270.000000000001" Width="1212" Height="990" />
                            </ObjectInfo>
                        </DieCutLabel>
                `)

            let done = false;
            dymo.label.framework.trace = true;
            dymo.label.framework.init(() => {
                const printers = dymo.label.framework.getPrinters();

                if (!printers.length) {
                    console.log("no supported printers found");
                    return done;
                }
                console.log("Printers: ", printers)
                try {

                    for(let labelXml of labels){
                        const label = dymo.label.framework.openLabelXml(labelXml);
                        label.print("DYMO LabelWriter 450");
                    }
                    done = true;
                } catch (error) {
                    console.log(error);
                }
            });

            return done;
        },
        editAttendee(att, checkin){//
            this.editData.registration = att;
            this.editData.recordedCheckpointFieldData = []
            this.editData.fields = []
            let data = this.fieldDatas.find(el => el.registration == att._id);
            this.fieldsToShow.forEach(f =>{
                let field = { ...f, value: "" }
                if(data && data.fields.length){
                    data.fields.forEach(el =>{
                        if(field._id == el._id){
                            field.value = el.value
                        }
                    })
                }
                else{
                    const reg = f.pullDataFromPrimaryRegistrant ? checkin.primaryRegistrant : att
                    let val = this.getFieldValueFromRegistration(f._id, reg);
                    if(val) field.value = val;
                }
                this.editData.fields.push(field);
            })
            this.editData.dialogOpen = true
        },
        handleCheckpointFieldDataChange(output){
            this.removeCheckpointFieldData(output.registration._id);
            this.editData.recordedCheckpointFieldData.push(output);
        },
        removeCheckpointFieldData(regId){
            this.editData.recordedCheckpointFieldData = this.editData.recordedCheckpointFieldData.filter(data => data.registration._id != regId);
        },
        getValueFromData(field, atId){
            let found = this.fieldDatas.find(el => el.registration == atId);
            if(!found) return "";
            let foundField = found.fields.find(f => f._id == field._id)
            if(foundField == -1) return "";
            return foundField && foundField.value ? foundField.value : "";
        },
        getValueForField(field, reg, checkin){
            if(!reg) return "";
            const found = this.fieldDatas.find(el => el.registration == reg._id);
            if(!found) {
                let registration = field.pullDataFromPrimaryRegistrant ? checkin.primaryRegistrant : reg;
                let val = this.getFieldValueFromRegistration(field._id, registration)
                
                if(val) return val;
                return ""
            }
            let foundField = found.fields.find(f => f._id == field._id)
            if(foundField == -1) return "";
            return foundField && foundField.value ? foundField.value : "";
        },
        getFieldValueFromRegistration(fieldId, registration){
            if(fieldId){
                let regFields = registration.fields;
                let field = regFields.find(el => el._id == fieldId)
                if(field && field.value != undefined) return field.value;
            }
            return null
        },
        searchUsingScanner(id){
            this.scannerDialogOpen = false
            this.filter.regNoOrId = id
            this.runFilter()
        },
        resetFilter(){
            this.filter = {
                status: null,
                name: null,
                regNoOrId: null,
                code: null,
                running: false
            }
            this.resetPagination()
            this.fetchCheckins()
        },
        resetPagination(){
            this.pagination = {
                total: 0,
                page: 1,
                perPage: 10
            }
        },
        async runFilter(){
            this.resetPagination();
            if((this.filter.status && this.filter.status.length) || this.filter.name ||this.filter.regNoOrId || this.filter.code) this.filter.running = true;
            else return;
            if(this.filter.status == null) this.filter.status = []
            this.loading = true
            this.checkins = [];
            try {
                const res = await http.post(`/api/checkpoints/search-checkins?perPage=${this.pagination.perPage}&page=${this.pagination.page}`, {
                    ...this.filter,
                    eventId: this.$route.params.eventId, 
                    checkpointId: this.$route.params.checkpointId
                });
                this.checkins = res.data.checkins;
                this.pagination = res.data.meta;
                this.stats = res.data.stats
            } catch (error) {
                this.$store.dispatch('handleErrors', error);
            }
            this.loading = false
        },
        async execCommand(obj){
            if(obj.action == "resend-confirmation-email") {
                try {
                   await http.post('/api/checkpoints/resend-confirmation-email', { id: obj.data._id })
                   this.$notify("confirmation email resent.")
                } catch (error) {
                    this.$store.dispatch('handleErrors', error)
                }
                return;
            }
            if(obj.action == "view-logs") {
                this.getLogs(obj.data._id)
                return;
            }
            if(obj.action == "edit") {
                this.noteData.dialogOpen = true
                this.noteData.idx = obj.idx
                this.noteData.checkin = {
                    ...obj.data
                }
                return;
            }
            if(obj.action == "view-registration") {
                if(!obj.data.primaryRegistrant) return this.$notify({ type: "danger", message: "primary registration id unavailable" });
                this.$router.push({ name : 'attendees',  query : { confirmationNumber: obj.data.attendees[0].confirmationNumber }})
                return;
            }

            if(this.checkins[obj.idx].status == "deleted") return;
            
            if(obj.action == "printed") {
               const done = this.print(obj.data);
               if(!done) return this.$notify({ type: "danger", message: "printing failed. Please check your printer connection and try again." })
            }
            if(obj.action == "deleted") {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete ? You won't be able to revert it back.`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (!confirmed)  return;
            }

            try {
                const res = await http.put('/api/checkpoints/checkin-status', { 
                    eventId: this.$route.params.eventId, 
                    checkinId: obj.data._id,
                    status: obj.action
                });

                if(obj.action == "printed") this.checkins[obj.idx].printed = true;
                if(obj.action == "removed-accepted") this.checkins[obj.idx].status = "checked-in";
                else this.checkins[obj.idx].status = obj.action;

                this.$notify({
                    message: res.data.message,
                    type: "info"
                })

                // this.fetchCheckins()

            } catch (error) {
                this.$store.dispatch('handleErrors', error)
            }
        },
        async updateCheckinNote(){
            this.loading = true
            try {
                const res = await http.put('/api/checkpoints/checkin-note', { 
                    eventId: this.$route.params.eventId, 
                    checkinId: this.noteData.checkin._id,
                    note: this.noteData.checkin.note
                });

                this.checkins[this.noteData.idx].note = this.noteData.checkin.note;

                this.$notify({
                    message: res.data.message,
                    type: "info"
                })
                this.noteData.dialogOpen = false
            } catch (error) {
                this.$store.dispatch('handleErrors', error)
                console.log(error);
                this.$notify({
                    message: "something went wrong",
                    type: "danger"
                })
            }
            this.loading = false
        },
        getColorForStatus(status){
            if(status == "checked-out") return "background: #000;";
            if(status == "accepted") return "background: green;";
            if(status == "printed") return "background: #409EFF;";
            if(status == "deleted") return "background: #e70202;";

            return "background: #e7ad02;"
        },
        refresh(){
            this.filter = {
                status: null,
                name: null,
                regNoOrId: null,
                code: null,
                running: false
            }
            this.fetchCheckins()
        },
        async fetchCheckins(){
            this.loading = true
            try {
                const res = await http.post(`/api/checkpoints/get-checkins?perPage=${this.pagination.perPage}&page=${this.pagination.page}`, { eventId: this.$route.params.eventId, checkpointId: this.$route.params.checkpointId });
                this.checkins = res.data.checkins;
                this.pagination =  res.data.meta;
                this.stats = res.data.stats
            } catch (error) {
                this.$store.dispatch('handleErrors', error);
            }
            this.loading = false
        },
        getData: async function () {
            this.initializing = true

            try {
                if (!this.$route.params.checkpointId) {
                    this.initializing = false
                    return
                }
                await this.fetchCheckins()
                
                const cf = await http.get(`/api/checkpointfields?eventId=${this.$route.params.eventId}`);
                this.checkpointFields = cf.data.fields;

                const cfd = await http.get(`/api/checkpointfields-data/admin?eventId=${this.$route.params.eventId}`);
                this.fieldDatas = cfd.data.data;


            } catch (error) {
                this.$store.dispatch('handleErrors', error)
                console.log(error);
                this.$notify({
                    message: "something went wrong",
                    type: "danger"
                })
            }

            this.initializing = false
        },
        getNameFromRegistration(registration){
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (lastName) name += lastName.value + ','
            if (firstName) name += firstName.value

            return name
        },
        async updateFields(){
            this.editData.loading = true
            try {
                const res = await http.post(`/api/checkpointfields-data/update-fields`, {
                    eventId: this.$route.params.eventId,
                    checkpointFieldData: this.editData.recordedCheckpointFieldData
                })
                this.$notify(res.data.message);
                let found = this.fieldDatas.find(el => el.registration == this.editData.registration._id);
                if(found) found.fields = this.editData.recordedCheckpointFieldData[0].fields;
                else this.fieldDatas.push({
                    registration: this.editData.registration._id,
                    fields: this.editData.recordedCheckpointFieldData[0].fields,
                    eventId: this.$route.params.eventId,
                    _id: new Date().getTime
                })
            } catch (error) {
                this.$store.dispatch('handleErrors', error);
            }
            this.resetEditData();
        },
        resetEditData(){
            this.editData.fields = []
            this.editData.registration = {}
            this.editData.recordedCheckpointFieldData = []
            this.editData.dialogOpen = false
            this.editData.loading = false
        },
        async downloadAsReport(){
            if(!this.userHasPermissions(['downloadCheckpointReports'])) return;
            this.downloading = true
            try {
                const response = await http.get(`/api/checkpoints/get-report?eventId=${this.$route.params.eventId}&checkpointId=${this.$route.params.checkpointId}`,{
                    responseType: 'arraybuffer'
                })
                download(response.data, 'checkpoint-attendees.xlsx', '	application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                this.$notify("Generated Checkpoint Attendees Report")
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading list')
            }
            this.downloading = false

        },
        getCreator(creator){
            if(!creator) return ""
            if(typeof creator == "string"){
                return creator;
            }
            return creator.email ? creator.email : ""
        }
    },
    async mounted() {
        let params = { filters: { eventId: this.$route.params.eventId } }
        if(!this.fields.length) await this.$store.dispatch('getAll', { path: 'fields', params })
        
        if(!this.checkpoints.length) 
        await this.$store.dispatch('getAll', {
            path: 'checkpoints',
            params: {
                filters: {
                    eventId: this.$route.params.eventId
                }
            }
        });
        this.checkpoint = this.checkpoints.find(el => el._id == this.checkpointId);

        await this.getData();

        this.checkpointFieldInfo = {}
        this.checkpoint.fieldsForCheckinAndAttendeesPage.forEach((el, order) =>{
            this.checkpointFieldInfo[el._id] = {
                pullDataFromPrimaryRegistrant: el.pullDataFromPrimaryRegistrant,
                order
            };
        })

        this.fields.forEach(el =>{
            if(Object.keys(this.checkpointFieldInfo).includes(el._id)){
                el.pullDataFromPrimaryRegistrant = this.checkpointFieldInfo[el._id].pullDataFromPrimaryRegistrant
                el.order = this.checkpointFieldInfo[el._id].order
                this.fieldsToShow.push(el)
            }
        });
        
        this.checkpointFields.forEach(el =>{
            if(Object.keys(this.checkpointFieldInfo).includes(el._id)){
                el.pullDataFromPrimaryRegistrant = this.checkpointFieldInfo[el._id].pullDataFromPrimaryRegistrant
                el.order = this.checkpointFieldInfo[el._id].order
                this.fieldsToShow.push(el)
            }
        });
        this.fieldsToShow.sort((a,b) => a.order - b.order);
    },
    filters: {
        registrationName: (registration) => {
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (firstName) name += firstName.value + ' '
            if (lastName) name += lastName.value

            return name
        },
        formatTimestamp: (date) => moment(date).format('DD MMM YYYY HH:mm')
    }
}
</script>

<style scoped>
.tables{
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.attendees__checkin-container{
    padding: 20px;
}

.attendees__heading{
    width:70%; 
    display: flex; 
    gap:10px; 
    justify-content: space-between; 
    font-weight: bold;
    font-size: 1rem;
    color: rgb(0, 149, 0);
}

.attendees__details-container{
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.attendees__details{
    width:70%;
    display: flex; 
    gap:10px; 
    justify-content: space-between;
}

.responsive-table {
    width: 100%;
    overflow-x: auto;
    position: relative;
}




/* Style the table */
table {
    width: 100%;
    border-collapse: collapse;
}

/* Style the table header */
th {
    background-color: #f2f2f2;
    color: black;
    padding: 15px;
    text-align: center;
}

th:nth-child(1){
    text-align: left;
}
/* Style the table cells */
td {
    border: 1px solid #ddd;
    padding: 10px 15px;
    text-align: center;
}

td:nth-child(1){
    text-align: left;
}

/* Add a hover effect to the rows */
tr:hover {
    background-color: #f5f5f5;
}

.status-tag{
    width: max-content;
}
</style>